import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Prismic, { getDocumentByUid } from 'helpers/Prismic';
import { globalPropsRequests } from 'utils/globalProps';
import StickyLinks from 'containers/ReadyToShip/StickyLinks';
import Head from 'next/head';
import GamingProductList from 'containers/CategoryLandingSlices/GamingProductList';
import PageHeader from 'components/PageHeader';
import Error from 'components/Error';
import breakPoints, { colors } from 'helpers/Styles';
import { Element, scroller } from 'react-scroll';
import Loader from 'components/Loader';
import { API } from 'lib/arkade-graphql';
import Script from 'next/script';
import WorkstationsCustomQuote from 'components/WorkstationsCustomQuote';
import { StorefrontContext } from 'providers/storefront';

const workstations = ({ content, featureListDOCS, pcModels }) => {
  const { isFallback, asPath } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  const { selectedGamingCategory } = useContext(StorefrontContext);

  const custom_quote = {
    title: content?.custom_quote_title || null,
    description: content?.custom_quote_description[0]?.text || null,
  };

  if (!content) {
    return <Error code={404} />;
  }

  const {
    seo_title: seoTitle,
    seo_description: seoDescription,
    title,
    description,
    body,
    og_image: ogImage,
    og_description: ogDescription,
  } = content;

  const [activeNav, setActiveNav] = useState(0);
  const listTitles = body.map((bodyItem) => bodyItem.primary.product_title);

  const handleActiveNav = (index) => {
    setActiveNav(index);
  };

  useEffect(() => {
    if (selectedGamingCategory !== null) {
      const closestIndex = listTitles.findIndex((title) => {
        let temp = '';

        temp = title.toLowerCase().split(' ')[0];

        let temp2 = '';

        if (
          selectedGamingCategory.toLowerCase() !== 'content creation' &&
          selectedGamingCategory.toLowerCase() !== 'engineering' &&
          selectedGamingCategory.toLowerCase() !== 'ai system'
        ) {
          temp2 = 'workstations';
        } else {
          temp2 = selectedGamingCategory.toLowerCase().split(' ')[0];
        }

        return temp.includes(temp2);
      });

      if (closestIndex !== -1) {
        scroller.scrollTo(listTitles[closestIndex], {
          duration: 1000,
          delay: 0,
          smooth: 'easeInOutQuart',
          offset: -80,
        });
      }
    }
  }, [selectedGamingCategory, asPath]);
  return (
    <>
      <Head>
        <link
          rel="preconnect dns-prefetch"
          href="https://triplewhale-pixel.web.app/"
          crossOrigin="true"
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://api.config-security.com/"
          crossOrigin="true"
        />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:description" content={ogDescription} />
        <meta
          property="og:image"
          content={
            ogImage?.url
              ? ogImage?.url
              : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
          }
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1024" />
        <meta property="og:image:height" content="1024" />
      </Head>
      <Script
        src="/tripleWhale.js"
        dangerouslySetInnerHTML={{
          __html: 'TripleHeadless = "aftershockpcau.myshopify.com" ',
        }}
        strategy="lazyOnload"
      />
      <main>
        {content?.desktop_banner &&
        Object.keys(content.desktop_banner).length !== 0 &&
        content?.mobile_banner &&
        Object.keys(content.mobile_banner).length !== 0 ? (
          <PageHeader
            bannerImage={content.desktop_banner}
            bannerImageMobile={content.mobile_banner}
            title={title}
            description={description[0]?.text}
          />
        ) : null}
        <div className="wrapper">
          {/* Added a new component for server workstations */}
          {custom_quote?.title !== null && (
            <WorkstationsCustomQuote custom_quote={custom_quote} />
          )}
          <div className="tabContent">
            <div className="sticky_list">
              <ul>
                {listTitles.map((item, listIndex) => (
                  <StickyLinks
                    item={item}
                    listIndex={listIndex}
                    key={item}
                    handleActiveNav={handleActiveNav}
                    activeNav={activeNav}
                  />
                ))}
              </ul>
            </div>
            <div className="gaming_product_list anchor-container">
              {body.map((bodyItem, index) => (
                <Element
                  name={listTitles[index]}
                  className="element"
                  key={index}
                >
                  <GamingProductList
                    data={bodyItem}
                    features={featureListDOCS}
                    fixedPrice
                    readyToShip={false}
                    pcModels={pcModels}
                  />
                </Element>
              ))}
            </div>
          </div>
        </div>
      </main>
      <style jsx>
        {`
          .tabContent {
            display: flex;
          }
          .sticky_list {
            flex: 1;
          }
          .sticky_list ul {
            position: sticky;
            top: 100px;
            padding-top: 50px;
            list-style-type: none;
            margin-bottom: 0px;
            padding-bottom: 16px;
            padding-left: 0px;
          }

          .gaming_product_list {
            flex: 3;
            display: flex;
            flex-direction: column;
            margin-left: auto;
          }
          button {
            padding: 15px 20px;
            background-color: ${colors.brandSecondary};
            font-family: 'Roboto-Bold';
          }
          .button_arrow {
            padding: 15px 20px;
            background-color: #242424;
          }
          main {
            background-color: ${colors.n500};
          }
          // .anchor-container {
          //   padding-top: 330px;
          //   margin-top: -330px;
          // }
          @media (max-width: ${breakPoints.medium}) {
            .tabContent {
              flex-direction: column;
              justify-content: center;
            }
            .gaming_product_list {
              width: 100%;
            }
            .sticky_list {
              position: sticky;
              top: 0px;
              background-color: black;
              z-index: 1;
            }

            .sticky_list ul {
              white-space: nowrap;
              overflow-x: scroll;
              padding-top: 10px;
              padding-right: 10px;
              display: flex;
            }
          }
          .bottom_info {
            padding: 60px 0 80px 0;
            color: #e4e4e4;
            font-family: 'Roboto-Normal';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            width: 30%;
            justify-content: center;
            margin: auto;
          }
          @media (max-width: ${breakPoints.medium}) {
            .bottom_info {
              width: 100%;
            }
          }
          @media (max-width: 425px) {
            .sticky_list::after {
              content: '';
              width: 60px;
              background: linear-gradient(
                to left,
                rgba(0, 0, 0, 1),
                rgba(0, 0, 0, 0.2)
              );
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        `}
      </style>
    </>
  );
};

export async function getStaticProps({ params, preview = false, previewData }) {
  const { handle } = params;
  const { ref } = previewData || {};
  const global = {};

  let menu = null;
  const contentOptions = {
    fetchLinks: ['pc_model.base_price', 'pc_model.base_price_compare_at'],
  };
  if (ref) contentOptions.ref = ref;

  const content = await Prismic.getByUID(
    'workstations_pag',
    `ws-${handle}`,
    contentOptions,
  ).then((res) => res?.data || null);

  if (!content) {
    return { notFound: true };
  }

  globalPropsRequests.push(
    Prismic.getByUID('page_menu', 'menu_ws', ref ? { ref } : null)
      .then((res) => ['menu_ws', res])
      .catch(() => null),
  );

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          if (id === 'menu_ws') menu = body.data;
          else global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  let featureListDOCS = [];

  if (content?.body) {
    const featureListIDs = content.body
      .map((productGroups) => productGroups.items)
      .flat()
      .map((item) => item?.features?.id)
      .filter((item, i, ar) => ar.indexOf(item) === i && item);
    //.map((item) => item?.features);

    featureListDOCS = await Prismic.getByIDs(
      featureListIDs,
      ref ? { ref } : null,
    ).then((res) => res?.results || []);
  }

  let pcModelIds = [];

  content.body.map((item) => {
    item.items.map((data) => {
      pcModelIds.push(data.pc_model.uid);
    });
  });

  const newPcModels = await Promise.all(
    pcModelIds.map(async (id) => {
      const document = await getDocumentByUid('pc_model', id);
      return {
        prismic_uid: id,
        seo_title: document?.data?.seo_title,
      };
    }),
  );

  const pcModels = await API.getPcModelBySlugsSmall(pcModelIds); // REDIS

  const updatedPcModels = pcModels.map((pcModel) => {
    const prismicModel = newPcModels.find(
      (newPcModel) => newPcModel.prismic_uid === pcModel.prismic_uid,
    );
    if (prismicModel) {
      pcModel.seo_title = prismicModel.seo_title;
    }
    return pcModel;
  });

  return {
    props: {
      global,
      handle,
      content,
      featureListDOCS,
      menu,
      preview,
      pcModels: updatedPcModels,
    },
    revalidate: 3600,
  };
}

export async function getStaticPaths() {
  return {
    paths: [
      { params: { handle: 'desktops' } },
      { params: { handle: 'laptops' } },
      { params: { handle: 'workstation' } },
    ],
    fallback: true,
  };
}

export default workstations;
